import { render, staticRenderFns } from "./VasReceiptModal.vue?vue&type=template&id=01b5fc5c"
import script from "./VasReceiptModal.vue?vue&type=script&lang=js"
export * from "./VasReceiptModal.vue?vue&type=script&lang=js"
import style0 from "./VasReceiptModal.vue?vue&type=style&index=0&id=01b5fc5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports